
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface TransactionPaymentMethodProps {
  displayPaymentMethod: string;
}

const TransactionPaymentMethod: React.FC<TransactionPaymentMethodProps> = ({ displayPaymentMethod }) => {
  return (
    <Card>
      <CardContent className="bg-[#F2F2F2] rounded-lg p-4">
        <h3 className="text-sm font-medium text-muted-foreground mb-1">Payment Method</h3>
        <p className="text-lg font-semibold capitalize shadow-none ">{displayPaymentMethod}</p>
      </CardContent>
    </Card>
  );
};

export default TransactionPaymentMethod;
